module.exports = __webpack_public_path__ + "img/public/SiteIcons/securityIcon3.svg?5f0999b3";